jQuery(function ($) {

  //ページ内リンク
  $('a[href^="#"]').on('click', function () {
    let time = 400;
    let header = $('.header').height();
    let target = $(this.hash);
    if (!target.length) return;
    let targetY = target.offset().top - header;
    $('html,body').animate({
      scrollTop: targetY
    }, time, 'swing');
    return false;
  });

  //動画自動再生
  $(window).on('scroll', function () {
    var conceptH = $('.concept-movie').offset().top;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll > conceptH - windowHeight + 100) {
      const videoElement = document.querySelector("video");
      // videoElement.muted = true;
      // videoElement.autoplay = true;
      videoElement.play();
    }
  });

  //トップへ戻る
  // var pagetop = $('.footer-content__top')
  // pagetop.click(function () {
  //   $('body, html').animate({
  //     scrollTop: 0
  //   }, 500);
  //   return false;
  // });

  //スライダー
  if (window.matchMedia('(max-width: 768px)').matches) {
    $("#js-slider").slick({
      autoplay: true, // 自動再生
      autoplaySpeed: 4000, // 再生速度（ミリ秒設定） 1000ミリ秒=1秒
      centerMode: true,
      slidesToShow: 1,
      centerPadding: "14%",
      infinite: true, // 無限スライド
    });
  } else {
    $("#js-slider").slick({
      autoplay: true, // 自動再生
      autoplaySpeed: 4000, // 再生速度（ミリ秒設定） 1000ミリ秒=1秒
      centerMode: true,
      slidesToShow: 1,
      centerPadding: "30%",
      infinite: true, // 無限スライド
    });
  }

  //ヘッダー
  $(window).scroll(function () {
    var scroll = $(this).scrollTop();
    if (scroll > 0) {
      $('header').addClass('is-active');
    }
  });

  //コンテンツフェードイン
  // $(window).on('scroll', function () {
  //   $('.js-fadein').each(function () {
  //     var elemPos = $(this).offset().top,
  //       scroll = $(window).scrollTop(),
  //       windowHeight = $(window).height();
  //     if (scroll > elemPos - windowHeight + 100) {
  //       $(this).addClass('fadein');
  //     }
  //   });
  //   $('.js-fadein_slow').each(function () {
  //     var elemPos = $(this).offset().top,
  //       scroll = $(window).scrollTop(),
  //       windowHeight = $(window).height();
  //     if (scroll > elemPos - windowHeight + 100) {
  //       $(this).delay(500).queue(function () {
  //         $(this).addClass('fadein').dequeue();
  //       });
  //     }
  //   });
  // });

  //ハンバーガーメニュー
  $('.header-hamburger').on('click', function () {
    $('.header-hamburger').toggleClass('is-active');
    $('.header-nav').toggleClass('is-active');
    $('header').toggleClass('is-active');
    $('body').toggleClass('js-nav__active');
  });

  $('.header-nav__item a').on('click', function () {
    $('.header-hamburger').removeClass('is-active');
    $('.header-nav').removeClass('is-active');
    $('header').removeClass('is-active');
    $('body').removeClass('js-nav__active');
  });

  //MW WP FORM スクロール位置調整
  if ($('.error')[0]) {
    $('.mw_wp_form').addClass('mw_wp_form_error');
    var errorEl = $('.mw_wp_form').eq(0);
    var position = errorEl.parent().offset().top - 85;
    $('body,html').delay(200).animate({
      scrollTop: position
    }, 600, 'linear');
  }

  //
  var params = (new URL(document.location)).searchParams;
  var tag_num = params.get("tag");
  // console.log(tag_num);
  if (tag_num == 'online') {
    $('.event-search__tag input').prop('checked', false);
    $('.event-search__tag input.tag-online').prop('checked', true);
  } else if (tag_num == 'real') {
    $('.event-search__tag input').prop('checked', false);
    $('.event-search__tag input.tag-real').prop('checked', true);

  } else {
    $('.event-search__tag input').prop('checked', false);
    $('.event-search__tag input.tag-all').prop('checked', true);
  }

  var selectTag = $('.event-search__tag input:checked').next('span').text();
  var selectCat = $('#cat option:selected').text();
  // console.log(selectTag);
  // console.log(selectCat);
  if (selectCat !== 'お選びください') {
    $('.archive-event__content__ttl__cat').text(selectCat);
  }

  //確認画面時表示切り替え
  if ($('.mw_wp_form_confirm').length) {
    $('.d-confirm').css('display', 'block');
    $('.btn-send').css('display', 'block');
    $('.btn-back').css('display', 'block');
    $('.btn-confirm').css('display', 'none');
    $('.contact-table__row.privacypolicy').css('display', 'none');
  }
});